// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": function componentCacheCachesGatsbyPluginOfflineAppShellJs() {
    return import("./../../.cache/caches/gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---node-modules-prismicio-gatsby-source-prismic-graphql-components-preview-page-js": function componentNodeModulesPrismicioGatsbySourcePrismicGraphqlComponentsPreviewPageJs() {
    return import("./../@prismicio/gatsby-source-prismic-graphql/components/PreviewPage.js"
    /* webpackChunkName: "component---node-modules-prismicio-gatsby-source-prismic-graphql-components-preview-page-js" */
    );
  },
  "component---src-pages-careers-js": function componentSrcPagesCareersJs() {
    return import("./../../src/pages/careers.js"
    /* webpackChunkName: "component---src-pages-careers-js" */
    );
  },
  "component---src-pages-contact-us-js": function componentSrcPagesContactUsJs() {
    return import("./../../src/pages/contact_us.js"
    /* webpackChunkName: "component---src-pages-contact-us-js" */
    );
  },
  "component---src-pages-e-commerce-js": function componentSrcPagesECommerceJs() {
    return import("./../../src/pages/e-commerce.js"
    /* webpackChunkName: "component---src-pages-e-commerce-js" */
    );
  },
  "component---src-pages-e-learning-js": function componentSrcPagesELearningJs() {
    return import("./../../src/pages/e-learning.js"
    /* webpackChunkName: "component---src-pages-e-learning-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-team-and-values-js": function componentSrcPagesTeamAndValuesJs() {
    return import("./../../src/pages/team_and_values.js"
    /* webpackChunkName: "component---src-pages-team-and-values-js" */
    );
  },
  "component---src-pages-travel-js": function componentSrcPagesTravelJs() {
    return import("./../../src/pages/travel.js"
    /* webpackChunkName: "component---src-pages-travel-js" */
    );
  },
  "component---src-pages-who-we-are-js": function componentSrcPagesWhoWeAreJs() {
    return import("./../../src/pages/who_we_are.js"
    /* webpackChunkName: "component---src-pages-who-we-are-js" */
    );
  },
  "component---src-templates-policy-js": function componentSrcTemplatesPolicyJs() {
    return import("./../../src/templates/policy.js"
    /* webpackChunkName: "component---src-templates-policy-js" */
    );
  }
};